import {AnankeText} from "@vesta/ananke/components/anankeText";

export function ProfileOverviewSectionHeader({
    title,
    actionLabel,
    onAction,
}: {
    title: string;
    actionLabel?: string;
    onAction?: () => void;
}) {
    return (
        <div className="flex min-w-0 shrink-0 items-center justify-between gap-x-ds-space-100">
            <AnankeText weight="bold">{title}</AnankeText>
            {onAction !== undefined && actionLabel !== undefined ? (
                <button
                    type="button"
                    onClick={onAction}
                    className="shrink-0 cursor-pointer border-0 bg-transparent p-0 text-sm font-medium text-ds-text-accent-blue hover:underline"
                >
                    {actionLabel}
                </button>
            ) : null}
        </div>
    );
}
